<template>
  <v-application v-if="access.item_list || access.item_composite_item">
    <v-layout row class="ma-2">
      <v-flex md12>
        <v-crud-card
          name="item"
          :to="router_link"
          :itemsView="itemsView"
          v-bind:importItem="importClick"
          v-bind:headers="item_headers"
          v-bind:data="data"
          v-bind:remove="remove"
          v-bind:num-pages="total"
          v-bind:download="download()"
          v-bind:add_button_name="'add_item'"
          v-model="page"
          Itemss
          v-bind:limit="limit"
          v-bind:all_categories="all_categories"
          v-bind:fetchCategories="fetchCategories"
          @change-pagination="changePagination"
          @change-limit="changeLimit"
          :loading_items_table_data="data_loading"
          :oneService="oneService"
          :has_variant="has_variant"
          @show-edit-cost="showEditCost"
          @edit-item-cost="editItemCost"
          @show-edit-price="showEditPrice"
          @edit-item-price="editItemPrice"
          @show-edit-in-stock="showEditInStock"
          @edit-item-in-stock="editItemInStock"
          @show-edit-mxik="showEditMxik"
          @edit-item-mxik="editItemMxik"
          @show-edit-nds-value="showEditNDS"
          @edit-item-nds-value="editItemNDS"
          @show-edit-reminder="showEditReminder"
          @edit-item-reminder="editItemReminder"
          @edit-item-category="editItemCategory"
          @open-variants="openVariants"
          @open-variant-dialog="openVariantDialogDetail"
          v-bind:orderHyperLink="orderHyperLink"
          :no-delete="!can_delete_item"
        >
          <template #top>
            <v-menu left offset-y>
              <template #activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>mdi-dots-horizontal</v-icon>
                </v-btn>
              </template>
              <v-list class="py-2 px-4">
                <v-list-item @click="printLabel">
                  <v-list-item-title>{{
                    $t(`print_labels`)
                  }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="createPricing">
                  <v-list-item-title>{{ $t(`pricing`) }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="Downloadexcel">
                  <v-list-item-title
                    >{{ $t(`export_item_excel`) }}
                  </v-list-item-title>
                </v-list-item>
                <!-- <v-list-item
                  v-if="store && store._id !== ''"
                  @click="itemImportExcel"
                >
                  <v-list-item-title>
                    {{ $t(`import_items_excel`) }}
                  </v-list-item-title>
                </v-list-item> -->
                <v-list-item
                  v-if="store && store._id !== ''"
                  @click="itemsForCasTurkish"
                >
                  <v-list-item-title>
                    {{ $t(`item_for_cas_turkish`) }}
                  </v-list-item-title>
                </v-list-item>

                <v-list-item
                  v-if="store && store._id !== ''"
                  @click="itemsForScale"
                >
                  <v-list-item-title>
                    {{ $t(`items_for_scale`) }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="store && store._id !== ''"
                  @click="itemsForScaleCAS"
                >
                  <v-list-item-title>
                    {{ $t(`items_for_scale_cas`) }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="store && store._id !== ''"
                  @click="itemsForScaleTxt"
                >
                  <v-list-item-title>
                    {{ $t(`items_for_scale_txt`) }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="store && store._id !== ''"
                  @click="itemsForScaleSecondTxt"
                >
                  <v-list-item-title>
                    {{ $t(`items_for_scale_second_txt`) }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="store && store._id !== ''"
                  @click="itemsForScaleThirdTxt"
                >
                  <v-list-item-title>{{ `RLS1200` }}</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="store && store._id !== ''"
                  @click="itemsForScaleShtrixM"
                >
                  <v-list-item-title>{{ `Shtrix M` }}</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="store && store._id !== ''"
                  @click="itemsForScaleShtrixMWeight"
                >
                  <v-list-item-title>{{
                    `Shtrix M(Weight)`
                  }}</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="store && store._id !== ''"
                  @click="itemsForScaleShtrixMCsv"
                >
                  <v-list-item-title>
                    {{ `Shtrix M Csv` }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="store && store._id !== ''"
                  @click="itemsForScaleMettletoledo"
                >
                  <v-list-item-title>
                    {{ $t(`item_for_mettletoledo`) }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="store && store._id !== ''"
                  @click="itemsForScaleMettletoledoSPCT1"
                >
                  <v-list-item-title>{{
                    $t(`item_for_mettletoledo_spct1`)
                  }}</v-list-item-title>
                </v-list-item>
                <!-- <v-list-item
                  v-if="store && store._id != ''"
                  @click="itemsForScaleShtrixM(1)"
                >
                  <v-list-item-title>{{ $t(`Shtrix M Encoded`) }}</v-list-item-title>
                </v-list-item> -->

                <v-list-item
                  v-if="category && category._id && category._id.length === 24"
                  @click="itemsExportByCategory"
                >
                  <v-list-item-title>
                    {{ $t(`export_by_category`) }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-spacer />
            <v-combobox
              v-if="!search_text"
              v-model="store"
              :label="$t(`stores`)"
              v-bind:items="stores"
              item-text="name"
              @change="changeStore"
              hide-details
              class="mx-1"
            />
            <v-combobox
              v-if="!search_text"
              v-model="category"
              :label="$t(`category`)"
              v-bind:items="all_top_categories"
              item-text="name"
              hide-details
              class="mx-1"
            />
            <v-combobox
              v-if="!search_text"
              v-model="supplier"
              :label="$t(`supplier`)"
              v-bind:items="all_suppliers_"
              item-text="supplier_name"
              hide-details
              class="mx-1"
            />
            <v-combobox
              v-if="!search_text"
              v-model="stock"
              :label="$t(`stock_alert`)"
              v-bind:items="stocks"
              hide-details
              class="mx-1"
            />
            <v-combobox
              v-if="!search_text"
              v-model="goods_sales_status"
              :label="$t(`status`)"
              v-bind:items="goods_sales_statuses"
              item-text="text"
              item-value="value"
              hide-details
              class="mx-1"
            />
            <v-slide-x-reverse-transition>
              <v-btn icon @click="searchActivate">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-slide-x-reverse-transition>
            <v-slide-x-reverse-transition>
              <v-text-field
                v-model="search"
                ref="search_field"
                v-if="search_text"
                :autofocus="search_field"
                class="mt-3 pa-0"
                append-icon="mdi-close"
                @click:append="
                  {
                    (search_text = false), (search = ''), searchingItems();
                  }
                "
                @change="searchingItems()"
                label="Search"
              ></v-text-field>
            </v-slide-x-reverse-transition>
            <v-menu left offset-y>
              <template #activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list class="py-2 px-4">
                <v-list-item @click="sort_by = 'name'">
                  <v-list-item-title>{{ $t(`name`) }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="sort_by = 'sku'">
                  <v-list-item-title>{{ $t(`sku`) }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="sort_by = 'stock'">
                  <v-list-item-title>{{ $t(`stock`) }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="sort_by = 'date'">
                  <v-list-item-title>{{ $t(`date`) }}</v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>
                    <v-btn icon @click="checkProcessAndOpenDialog">
                      <v-icon color="black">mdi-arrow-left-right</v-icon>
                    </v-btn>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>
                    <v-btn icon @click="syncWithMxikFinderOpenDialog">
                      <v-icon color="black">mdi-sync</v-icon>
                    </v-btn>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-dialog v-model="edit_prices_all_dialog" :width="800" persistent>
              <v-card>
                <v-card-title>{{ $t("pricing") }}</v-card-title>
                <v-card-text>
                  <v-layout px-2 row>
                    <v-flex md6 px-2>
                      <v-autocomplete
                        v-model="first_service"
                        :label="$t('source_store')"
                        :items="price_services"
                        item-text="name"
                        item-value="_id"
                      />
                    </v-flex>

                    <v-flex md6 px-2>
                      <v-autocomplete
                        v-model="second_service"
                        :label="$t('destination_store')"
                        :items="price_services"
                        item-value="_id"
                        item-text="name"
                      />
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    text
                    @click="
                      edit_prices_all_dialog = false;
                      first_service = null;
                      second_service = null;
                    "
                  >
                    {{ $t("cancel") }}
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    :disabled="disableConfirm"
                    @click="setServicePrices"
                    >{{ $t("confirm") }}</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="sync_with_mxik_finder_dialog" :width="800" persistent>
              <v-card>
                <v-card-title>{{ $t("sync") }}</v-card-title>
                <v-card-text>
                  <div v-if="sync_with_mxik_finder_process != null">
                  <v-row align="start" justify="space-between">
                    <v-col cols="6" md="6" sm="6">
                      {{ $t('startedAt') }}:
                    </v-col>
                    <v-col cols="6" md="6" sm="6">
                      {{ date_ddmmyy_hhmm(new Date(sync_with_mxik_finder_process.startedAt).getTime()) }}
                    </v-col>
                  </v-row>

                  <v-row align="start" justify="space-between">
                    <v-col cols="6" md="6" sm="6">
                      {{ $t('endedAt') }}:
                    </v-col>
                    <v-col cols="6" md="6" sm="6">
                      {{
                        sync_with_mxik_finder_process
                          ? date_ddmmyy_hhmm(new Date(sync_with_mxik_finder_process.endedAt).getTime())
                          : ''
                      }}
                    </v-col>
                  </v-row>

                  <v-row align="start" justify="space-between">
                    <v-col cols="6" md="6" sm="6">
                      {{ $t('syncProductsCount') }}:
                    </v-col>
                    <v-col cols="6" md="6" sm="6">
                      {{ sync_with_mxik_finder_process.syncProductsCount }}
                    </v-col>
                  </v-row>

                  <v-row align="start" justify="space-between">
                    <v-col cols="6" md="6" sm="6">
                      {{ $t('checkedProductsCount') }}:
                    </v-col>
                    <v-col cols="6" md="6" sm="6">
                      {{ sync_with_mxik_finder_process.checkedProductsCount }}
                    </v-col>
                  </v-row>

                  </div>
                  <div v-else> {{ $t('syncNotStarted') }} </div>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    text
                    @click="sync_with_mxik_finder_dialog = false;"
                  >
                    {{ $t("cancel") }}
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    :disabled="sync_with_mxik_finder_started"
                    @click="syncWithMxikFinderStart"
                    >{{ $t("sync") }}</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="exceldialog" max-width="500px">
              <v-card>
                <v-card-title v-if="excelwait"
                  >Iltimos, kutib turing!
                  {{ exceldialogPercentage }}%</v-card-title
                >
                <v-card-title v-else>Excel yuklashga tayyor!</v-card-title>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn
                    text
                    color="primary"
                    @click="saveExcel"
                    :disabled="excelwait"
                  >
                    <export-excel :data="downExcel" :name="excel_name"
                      >Save Excel</export-excel
                    >
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </v-crud-card>
      </v-flex>
    </v-layout>
    <v-variant-detail-dialog
      v-bind:variant_detail_dialog="variant_detail_dialog"
      v-bind:updateItemVariant="updateItemVariant"
      v-bind:updateItemVariantActionGlobal="updateItemVariantActionGlobal"
      v-bind:closeVariantDialog="closeVariantDialog"
      v-bind:current_item="current_item"
      v-bind:moneyOptions="moneyOptions"
      v-bind:services_headers="services_headers"
      v-bind:option_names="option_names"
      v-bind:variant_dialog_error="variant_dialog_error"
      v-bind:variant_dialog_error_text="variant_dialog_error_text"
    />
    <v-dialog v-model="prices_all_dialog_processing" :width="50">
      <v-card :width="50" :height="50" class="ma-0 pa-0">
        <v-container fill-height fluid class="ma-0 pa-0">
          <v-row align="center" justify="center" class="ma-0 pa-0">
            <v-col class="ma-0 pa-0 ml-2">
              <v-progress-circular indeterminate color="primary" />
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_import_item" width="500">
      <v-card>
        <v-card-title>{{ $t("import") }}</v-card-title>
        <v-card-text>
          <a href="http://purch.invan.uz/static/customers.xlsx"
            >Download template file</a
          >
          and fill in with the customers information.
        </v-card-text>
        <v-card-text>
          <v-file-input
            v-model="file"
            accept=".xlsx"
            label="Select File..."
            show-size
            filled
          ></v-file-input>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text v-on:click="dialog_import_item = false">{{
            $t(`cancel`)
          }}</v-btn>
          <v-btn text color="primary" v-on:click="uploading">{{
            $t(`upload`)
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-application>

  <error404 v-else></error404>
</template>
<script>
import Services from "../mixins/services";
import Categories from "../mixins/items/categories";
import Suppliers from "../mixins/inventory/supplier";
const AllSuppliers = Object.assign(
  { ...Suppliers },
  {
    mounted() {
      this.get_all_suppliers();
    },
  },
);
import ItemsMixin from "../mixins/items/item";
import ItemVariantDialog from "../mixins/items/item-variant-dialog";
import Userable from "../mixins/userable";
import category from "@/views/reports/Category";

export default {
  loading: false,
  name: "Items",
  mixins: [
    Services,
    Categories,
    ItemsMixin,
    ItemVariantDialog,
    AllSuppliers,
    Userable,
  ],
  data: () => ({
    data: [],
    item_headers: [],
    goods_sales_status: null,
    goods_sales_statuses: [],
    stocks: [
      { text: "All items", value: "all" },
      { text: "Low stock", value: "low" },
      { text: "Out of stock", value: "out" },
    ],
    user: null,
    stock: null,
    page: 1,
    limit: 10,
    data_loading: false,
    numPages: 1,
    total: 0,
    has_variant: false,
    search_text: false,
    search: "",
    showItem: null,
    showReminder: null,
    search_field: false,
    itemsView: true,
    composite_item: false,
    store_item: false,
    router_link: "/items/list",
    sort_by: "date",
    downExcel: [],
    excel_name: "ExcelItems",
    exceldialog: false,
    exceldialogPercentage: 0,
    excelwait: true,
    prices_all_dialog_processing: false,
    edit_prices_all_dialog: false,
    sync_with_mxik_finder_dialog: false,
    sync_with_mxik_finder_started: false,
    sync_with_mxik_finder_process: null,
    first_service: null,
    second_service: null,
    dialog_import_item: false,
    file: null,
    items_data: [],
  }),
  computed: {
    can_delete_item() {
      if (!this.access_rights_list) {
        return false;
      }
      if (this.stock === 0) {
        return false;
      }
      return this.access_rights_list.can_delete_item;
    },
    oneService() {
      return this.store && this.store._id !== "";
    },
    target() {
      return this.$route.params["target"];
    },
    price_services() {
      if (!(this.stores instanceof Array)) {
        return [];
      }
      const services = [];
      for (const s of this.stores) {
        if (s._id) {
          services.push(s);
        }
      }
      return services;
    },
    disableConfirm() {
      if (!this.first_service) return true;
      if (!this.second_service) return true;
      if (this.first_service === this.second_service) return true;
      return false;
    },
  },
  beforeMount() {
    this.page = this.$store.state.items_current_page;
    this.store = this.$store.state.items_current_service;
    this.stock = this.$store.state.stock_item;
    if (this.stock && !this.stock.text) {
      this.stock.text = this.$t("all_categories");
    }
    this.sort_by = this.$store.state.items_current_sort_by;
    if (this.store && !this.store.name) {
      this.store.name = this.$t("all_stores");
    }
    this.supplier = this.$store.state.supplier1;
    if (this.supplier && !this.supplier.supplier_name) {
      this.supplier.supplier_name = this.$t("all_suppliers");
    }
    this.category = this.$store.state.category1;
    if (this.category && !this.category.name) {
      this.category.name = this.$t("all_categories");
    }
    this.access = this.$store.state.access;
    if (this.$store.state.item_list_headers) {
      this.item_headers = this.$store.state.item_list_headers;
    } else {
      this.change_item_headers();
    }

    this.goods_sales_statuses = [
      { text: "All items", value: "all" },
      { text: this.$t("active"), value: "active" },
      { text: this.$t("inactive"), value: "inactive" },
    ]
    this.goods_sales_status = {
      text: this.$t("all_statuses"),
      value: "all",
    }
  },
  methods: {
    changeStore() {
      // this.change_item_headers();
    },
    async change_item_headers() {
      const services = this.$communicator.then(
        this,
        await this.$communicator("services"),
      );
      let headers = [
        {
          text: this.$t(`sku`),
          value: "sku",
          available: true,
          sortable: false,
        },
        {
          text: this.$t(`image`),
          value: "representation",
          available: true,
          sortable: false,
        },
        {
          text: this.$t(`item_name`),
          value: "name",
          align: "left",
          available: true,
          sortable: false,
          disabled: true,
        },
        {
          text: this.$t(`barcode`),
          value: "barcode",
          available: true,
          sortable: false,
        },
        {
          text: this.$t(`category`),
          value: "category_name",
          available: true,
          sortable: false,
        },
        {
          text: this.$t(`mxik`),
          value: "mxik",
          available: true,
          sortable: false,
          width: 190,
        },
        {
          text: this.$t(`nds_value`),
          value: "nds_value",
          available: true,
          sortable: false,
          width: 90,
        },
        {
          text: this.$t(`price`),
          value: "price",
          align: "right",
          available: true,
          sortable: false,
        },
        {
          text: this.$t(`cost`),
          value: "cost",
          align: "right",
          available: true,
          sortable: false,
        },
        {
          text: this.$t(`margin`),
          value: "margin",
          align: "right",
          available: true,
          sortable: false,
        },
        {
          text: this.$t(`reminder`),
          value: "reminder",
          align: "right",
          available: true,
          sortable: false,
        },
        {
          text: this.$t(`in_stock`),
          value: "in_stock",
          align: "right",
          width: 100,
          available: true,
          sortable: false,
        },
      ];
      if(!Array.isArray(services)) {
        return
      }

      const headersStockStore = services
        .filter((s) => s._id)
        .map((store) => {
          return {
            text: `${this.$t("in_stock")} (${store.name})`,
            value: `storeStock.${store.name}`,
            align: "left",
            available: true,
            sortable: false,
            width: 150,
          };
        });
      headers = [...headers, ...headersStockStore];
      this.item_headers = headers;
      this.$store.commit("serItemListHeaders", this.item_headers);
      return this.item_headers;
    },
    itemImportExcel() {
      this.dialog_import_item = true;
    },
    async uploading() {
      const service_id = this.store ? this.store._id : "";
      const org_id = this.user ? this.user.organization : "";
      const link = `/inventory/${org_id}/${service_id}`;
      await this.$communicator.file1(link, { file: this.file });
      this.dialog_import_item = false;
    },
    printLabel() {
      // window.location.href = "/items/create-label";
      this.$router.push("/items/create-label/label");
    },
    createPricing() {
      this.$router.push("/items/create-pricing/pricing");
    },
    itemsForCasTurkish() {
      const service_id = this.store ? this.store._id : "";
      const org_id = this.user ? this.user.organization : "";
      const link = `invan-download/items/get/cas-turkish/excel/${org_id}/${service_id}/items.xls`;
      this.$communicator.downloadDocument(link, `items.xls`);
    },
    itemsForScale() {
      const service_id = this.store ? this.store._id : "";
      const org_id = this.user ? this.user.organization : "";
      const link = `items/get/excel/${org_id}/${service_id}/items.xls`;
      this.$communicator.downloadDocument(link, `items.xls`);
    },
    itemsForScaleCAS() {
      const service_id = this.store ? this.store._id : "";
      const org_id = this.user ? this.user.organization : "";
      const link = `items/get/excel-cas/${org_id}/${service_id}/items.xlsx`;
      this.$communicator.downloadDocument(link, `items.xlsx`);
    },
    itemsForScaleTxt() {
      const service_id = this.store ? this.store._id : "";
      const org_id = this.user ? this.user.organization : "";
      const link = `items/get/txt/${org_id}/${service_id}/items.txt`;
      this.$communicator.downloadDocument(link, `items.txt`);
    },
    itemsForScaleSecondTxt() {
      const service_id = this.store ? this.store._id : "";
      const org_id = this.user ? this.user.organization : "";
      const link = `items/get/second-txt/${org_id}/${service_id}/items.txt`;
      this.$communicator.downloadDocument(link, `items.txt`);
    },
    itemsForScaleThirdTxt() {
      const service_id = this.store ? this.store._id : "";
      const org_id = this.user ? this.user.organization : "";
      const link = `items/get/third-txt/${org_id}/${service_id}/items.txt`;
      this.$communicator.downloadDocument(link, `items.txt`);
    },
    itemsForScaleShtrixM(is_encode = 0) {
      const service_id = this.store ? this.store._id : "";
      const org_id = this.user ? this.user.organization : "";
      const link =
        `items/get/shtrix-m/` +
        (is_encode == 1 ? "encoded/" : "") +
        `${org_id}/${service_id}/items.txt`;
      this.$communicator.downloadDocument(link, `items.txt`);
    },
    itemsForScaleShtrixMWeight() {
      const service_id = this.store ? this.store._id : "";
      const org_id = this.user ? this.user.organization : "";
      const link = `items/get/shtrix-m-weight/${org_id}/${service_id}/items.txt`;
      this.$communicator.downloadDocument(link, `items.txt`);
    },
    itemsForScaleShtrixMCsv() {
      const service_id = this.store ? this.store._id : "";
      const org_id = this.user ? this.user.organization : "";
      const link = `invan-download/items/get/shtrix-m/csv/${org_id}/${service_id}/items.csv`;
      this.$communicator.downloadDocument(link, `items.csv`);
    },
    itemsForScaleMettletoledo() {
      const service_id = this.store ? this.store._id : "";
      const org_id = this.user ? this.user.organization : "";
      const link = `invan-download/items/get/mettletoledo/${org_id}/${service_id}/items.txt`;
      this.$communicator.downloadDocument(link, `items.txt`);
    },
    itemsForScaleMettletoledoSPCT1() {
      const service_id = this.store ? this.store._id : "";
      const org_id = this.user ? this.user.organization : "";
      const link = `invan-download/items/get/mettletoledo-spct1/${org_id}/${service_id}/items.txt`;
      this.$communicator.downloadDocument(link, `items.txt`);
    },
    itemsExportByCategory() {
      const org_id = this.user ? this.user.organization : "";
      const token = this.user ? this.user.token : "";
      const category_id = this.category ? this.category._id : "";
      const category_name = this.category
        ? this.category.name
        : "itemsByCategory";
      const link = `invan-download/item-by-category/excel/${token}/${org_id}/${category_id}/${category_name}.xls`;
      this.$communicator.downloadDocument(link, `${category_name}.xls`);
    },
    importClick() {
      this.$router.push("/items/import?org=" + this.user.organization);
    },
    // exportClicked() {
    //   "/goods/sales/export/:organization/:name";
    // },
    download() {
      if (this.user) {
        return (
          "goods/sales/export/" + this.user.organization + "/exported_items.csv"
        );
      } else {
        return "";
      }
    },
    searchActivate() {
      this.search_text = true;
      if (this.search_field && this.$refs["search_field"]) {
        this.$refs["search_field"].focus();
      }
      this.search_field = true;
    },
    changePagination(page) {
      this.page = page;
      this.update_items();
    },
    changeLimit(limit) {
      this.limit = limit;
      this.update_items();
    },
    showEditCost(id, state) {
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id === id) {
          this.data[i].show_edit_cost = state;
        } else {
          this.data[i].show_edit_cost = false;
        }
      }
      this.data.push({});
      this.data.pop();
    },
    async editItemCost(id, cost) {
      let index = null;
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id === id) {
          index = i;
        }
        this.data[i].show_edit_cost = false;
      }
      const res = await this.update_goods_sales(id, {
        cost: cost,
        category: this.data[index].category,
      });
      if (res && res.data && res.data.statusCode === 200) {
        this.data[index].cost = cost;
        this.data.push({});
        this.data.pop();
      }
    },
    showEditPrice(id, state) {
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id === id) {
          this.data[i].show_edit_price = state;
        } else {
          this.data[i].show_edit_price = false;
        }
      }
      this.data.push({});
      this.data.pop();
    },
    async editItemPrice(id, price) {
      let index = null;
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id === id) {
          index = i;
          this.data[i].price = price;
        }
        this.data[i].show_edit_price = false;
      }
      const res = await this.update_goods_sales(id, {
        price: price,
        service: this.store._id,
      });
      if (res && res.data && res.data.statusCode === 200) {
        this.data[index].price = price;
        // typeof price != "number"
        //   ? Number(price).toLocaleString()
        //   : price.toLocaleString();
        this.data.push({});
        this.data.pop();
      }
    },
    showEditInStock(id, state) {
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id === id) {
          this.data[i].show_edit_in_stock = state;
        } else {
          this.data[i].show_edit_in_stock = false;
        }
      }
      this.data.push({});
      this.data.pop();
    },
    showEditMxik(id, state) {
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id === id) {
          this.data[i].show_edit_mxik = state;
        } else {
          this.data[i].show_edit_mxik = false;
        }
      }
      this.data.push({});
      this.data.pop();
    },
    showEditNDS(id, state) {
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id === id) {
          this.data[i].show_edit_nds_value = state;
        } else {
          this.data[i].show_edit_nds_value = false;
        }
      }
      this.data.push({});
      this.data.pop();
    },
    showEditReminder(id, state) {
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id === id) {
          this.data[i].show_edit_reminder = state;
        } else {
          this.data[i].show_edit_reminder = false;
        }
      }
      this.data.push({});
      this.data.pop();
    },
    async editItemInStock(id, in_stock) {
      in_stock = +in_stock;
      let index = null;
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id === id) {
          index = i;
        }
        this.data[i].show_edit_in_stock = false;
      }
      this.showItem = this.data[index];
      const res = await this.update_goods_sales(id, {
        in_stock: in_stock,
        service: this.store._id,
      });
      if (res && res.data && res.data.statusCode === 200) {
        this.data[index].in_stock = in_stock;
        this.showItem = this.data[index];
        this.data.push({});
        this.data.pop();
      }
    },
    async editItemMxik(id, mxik) {
      mxik = +mxik;
      let index = null;
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id === id) {
          index = i;
        }
        this.data[i].show_edit_mxik = false;
      }
      this.showItem = this.data[index];
      const res = await this.update_goods_sales(id, {
        mxik: mxik,
        service: this.store._id,
      });
      if (res && res.data && res.data.statusCode === 200) {
        this.data[index].mxik = mxik;
        this.showItem = this.data[index];
        this.data.push({});
        this.data.pop();
      }
    },
    async editItemNDS(id, nds_value) {
      nds_value = +nds_value;
      let index = null;
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id === id) {
          index = i;
        }
        this.data[i].show_edit_nds_value = false;
      }
      this.showItem = this.data[index];
      const res = await this.update_goods_sales(id, {
        nds_value: nds_value,
        service: this.store._id,
      });
      if (res && res.data && res.data.statusCode === 200) {
        this.data[index].nds_value = nds_value;
        this.showItem = this.data[index];
        this.data.push({});
        this.data.pop();
      }
    },
    async editItemReminder(id, reminder) {
      reminder = +reminder;
      let index = null;
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id === id) {
          index = i;
        }
        this.data[i].show_edit_reminder = false;
      }
      this.showReminder = this.data[index];
      const res = await this.update_goods_sales(id, {
        reminder: reminder,
        service: this.store._id,
      });
      if (res && res.data && res.data.statusCode === 200) {
        this.data[index].reminder = reminder;
        this.showReminder = this.data[index];
        this.data.push({});
        this.data.pop();
      }
    },
    async editItemCategory(id, category) {
      let index = null;
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id === id) {
          index = i;
        }
      }
      const res = await this.update_goods_sales(id, {
        category: category.id,
        category_name: category.name,
      });
      if (res && res.data && res.data.statusCode === 200) {
        this.data[index].category_name = category.name;
        this.data[index].category = category.id;
        this.data.push({});
        this.data.pop();
      }
    },
    async openVariants(item, state) {
      this.data_loading = true;
      let index = null;
      const data = [];
      for (let i = 0; i < this.data.length; i++) {
        data.push(this.data[i]);
        if (this.data[i]._id === item._id) {
          index = i;
          break;
        }
      }
      if (state) {
        const res = await this.get_item_variants({
          item_id: item._id,
          services: this.store && this.store._id !== "" ? [this.store._id] : [],
        });
        if (res && res.data && res.data.statusCode === 200) {
          data[index].open_variants = true;
          const res_data = res.data.data;
          for (let i = 0; i < res_data.length; i++) {
            data.push(res_data[i]);
          }
        }
        for (let i = index + 1; i < this.data.length; i++) {
          data.push(this.data[i]);
        }
      } else {
        data[index].open_variants = false;
        let k = null;
        for (let i = index + 1; i < this.data.length; i++) {
          if (this.data[i].item_type === "item") {
            k = i;
            break;
          }
        }
        if (k) {
          for (let i = k; i < this.data.length; i++) {
            data.push(this.data[i]);
          }
        }
      }
      this.data = data;
      this.data_loading = false;
    },
    async remove(items) {
      var indices = [];
      for (const index in items) {
        indices.push(items[index]._id);
      }
      await this.$communicator("remove_items", {
        params: {
          indexes: indices,
        },
      });
      this.$toast.success("Success", { timeout: 2000 });
      this.update_items();
    },
    searchingItems() {
      const query = { ...this.$route.query, search: this.search };
      this.$router.push({ path: this.$route.path, query: query });
      this.update_items();
    },
    async update_items() {
      this.data_loading = true;
      const items = this.$communicator.then(
        this,
        await this.$communicator("list_of_items", {
          arguments: [this.limit, this.page],
          params: {
            service: this.store && this.store._id !== "" ? this.store._id : "",
            composite_item:
              this.category && this.category._id === 123
                ? true
                : this.category && this.category._id === 1234
                ? false
                : null,
            store_item:
              this.category && this.category._id === 234
                ? true
                : this.category && category._id === 2345
                ? false
                : null,
            category:
              this.category && this.category._id ? this.category._id : "",
            supplier_id:
              this.supplier && this.supplier._id ? this.supplier._id : "",
            stock: this.stock.value,
            name: this.search_text ? this.search : "",
            sort_by: this.sort_by,
            is_active: this.goods_sales_status.value
          },
        }),
      );
      if (items) {
        this.total = items.page;
        var has_variant = false;

        // var stock_status = false;
        for (let i = 0; i < items.data?.length; i++) {
          has_variant = has_variant || items.data[i].has_variants;
          if (this.store && this.store._id != "") {
            items.data[i].one_service = true;
          }
          if (items.data[i].stock_status) {
            if (
              items.data[i].stock_status.low_stock > 0 ||
              items.data[i].stock_status.out_of_stock > 0
            ) {
              // stock_status = true;
            }
          }
          const storeStock = {};
          items.data[i].services.map((s) => {
            storeStock[s.service_name] = s.in_stock;
          });
          items.data[i].storeStock = storeStock;
        }
        this.has_variant = has_variant;
        this.data = items.data;
        this.numPages = items.page;
      }
      this.data_loading = false;
    },

    async Downloadexcel() {
      this.exceldialog = true;
      this.loading = true;
      this.downExcel = [];
      const totalPages = Math.ceil(this.total / 10);
      for (let i = 1; i <= totalPages; i++) {
        const items = this.$communicator.then(
          this,
          await this.$communicator("list_of_items", {
            arguments: [100, i],
            params: {
              service:
                this.store && this.store._id !== "" ? this.store._id : "",
              composite_item:
                this.category && this.category._id === 123
                  ? true
                  : this.category && this.category._id === 1234
                  ? false
                  : null,
              store_item:
                this.category && this.category._id === 234
                  ? true
                  : this.category && category._id === 2345
                  ? false
                  : null,
              category:
                this.category && this.category._id ? this.category._id : "",
              supplier_id:
                this.supplier && this.supplier._id ? this.supplier._id : "",
              stock: this.stock.value,
              name: this.search_text ? this.search : "",
              sort_by: this.sort_by,
            },
          }),
        );
        this.exceldialogPercentage = ((100 * i) / totalPages).toFixed(2);
        this.downExcel.push(
          ...items?.data.map((itm) => ({
            sku: itm.sku,
            name: itm.name,
            sold_by: this.$t(itm.sold_by),
            category: itm.category_name,
            barcode: itm.barcode,
            cost: Math.round(itm.cost),
            price: itm.price,
            margin:
              itm.price && itm.cost
                ? (((itm.price - itm.cost) / itm.cost) * 100).toFixed(2)
                : 0,
            in_stock: itm.in_stock,
            _id: itm._id,
          })),
        );
      }

      // const result = items?.data.map((itm) => ({
      //   sku: itm.sku,
      //   name: itm.name,
      //   sold_by: this.$t(itm.sold_by),
      //   category: itm.category_name,
      //   barcode: itm.barcode,
      //   cost: Math.round(itm.cost),
      //   price: itm.price,
      //   margin:
      //     itm.price && itm.cost
      //       ? (((itm.price - itm.cost) / itm.cost) * 100).toFixed(2)
      //       : 0,
      //   in_stock: itm.in_stock,
      //   _id: itm._id,
      // }));
      // this.downExcel = result;
      setTimeout(() => (this.excelwait = false), 3000);
    },
    saveExcel() {
      this.exceldialog = false;
      this.excelwait = true;
      this.downExcel = [];
    },
    orderHyperLink(item) {
      this.$router.push(
        `/inventory/workgroup/orders/create?service=${
          this.store._id
        }&item_name=${item.name}&item_id=${item._id}&order_item_count=${
          item.in_stock * -1
        }`,
      );
    },
    async checkProcessAndOpenDialog() {
      const result = this.$communicator.then(
        this,
        await this.$communicator("pricing_process_check"),
      );
      if (!result || result.processing) {
        this.prices_all_dialog_processing = true;
        return;
      }
      this.edit_prices_all_dialog = true;
    },

    async syncWithMxikFinderOpenDialog() {
      const org_id = this.user ? this.user.organization : "";
      const result = this.$communicator.then(
        this,
        await this.$communicator("sync_with_mxik_finder_get_process",
        {
            params: { organization_id: org_id }
          }
        ),
      );
      this.sync_with_mxik_finder_dialog = true;

      if(result.statusCode == 404) {
        this.sync_with_mxik_finder_started = false
        return
      }
      this.sync_with_mxik_finder_started = result.endedAt == null

      this.sync_with_mxik_finder_process = result
    },

    async syncWithMxikFinderStart() {
      this.sync_with_mxik_finder_started = true
      const org_id = this.user ? this.user.organization : "";
      this.$communicator.then(
        this,
        await this.$communicator("sync_with_mxik_finder_start",
          {
            params: { organization_id: org_id }
          }
        ),
      );

      this.sync_with_mxik_finder_dialog = false;
    },

    async setServicePrices() {
      const result = await this.$communicator("set_service_price", {
        params: {
          first_service_id: this.first_service,
          second_service_id: this.second_service,
        },
      });
      if (result) {
        this.prices_all_dialog_processing = true;
        this.edit_prices_all_dialog = false;
        this.first_service = null;
        this.second_service = null;
      } else {
        this.prices_all_dialog_processing = false;
        this.edit_prices_all_dialog = false;
        this.first_service = null;
        this.second_service = null;
      }
    },

    formatDate(d) {
      return this.date_ddmmyy_hhmm(new Date(d).getTime())
    }
  },
  watch: {
    sort_by() {
      this.$store.commit("setItemSortBy", this.sort_by);
      this.update_items();
    },
    category() {
      this.$store.commit("setCategory", this.category);
      this.update_items();
    },
    supplier() {
      this.$store.commit("setSupplier", this.supplier);
      this.update_items();
    },
    store() {
      this.$store.commit("setItemsService", this.store);
      this.update_items();
    },
    page() {
      this.$store.commit("setItemsPage", this.page);
    },
    limit() {
      this.$store.commit("setItemsLimit", this.limit);
    },
    stock() {
      // if (this.stock && this.stock.value !== "all") {
      //   this.page = 1;
      // }
      this.$store.commit("setStock", this.stock);
      this.update_items();
    },
    goods_sales_status(){
      this.$store.commit("goodsSalesStatus", this.goods_sales_status);
      this.update_items();
    },
    prices_all_dialog_processing() {
      if (this.prices_all_dialog_processing) {
        this.prices_all_dialog_processing_time = new Date().getTime();
        setTimeout(() => {
          const current_time = new Date().getTime();
          if (current_time - this.prices_all_dialog_processing_time > 3500) {
            this.prices_all_dialog_processing = false;
          }
        }, 4000);
      }
    },
    all_top_categories() {
      if (
        this.all_top_categories &&
        this.all_top_categories.length > 0 &&
        this.all_top_categories[0]._id !== ""
      ) {
        this.all_top_categories = [
          { name: this.$t("all_categories"), _id: "" },
          // { name: this.$t("composite_items"), _id: 123 },
          // { name: this.$t("non_composite"), _id: 1234 },
          // { name: this.$t("store_items"), _id: 234 },
          // { name: this.$t("non_store"), _id: 2345 },
        ].concat(this.all_top_categories);
      }
    },
    target() {
      if (this.target === "composite") {
        this.category = { name: this.$t("composite_item"), _id: 123 };
        this.router_link = "/items-list/composite";
      } else if (this.target === "store") {
        this.category = { name: this.$t("store_items"), _id: 234 };
        this.router_link = "/items-list/store";
      } else {
        this.category = { name: this.$t("all_categories"), _id: "" };
        this.router_link = "/items/list";
      }
    },
  },
  mounted() {
    const query = this.$route.query;
    if (query && query.search) {
      if (this.search != query.search) {
        this.search = query.search;
        this.search_text = true;
        this.$router.push({
          path: this.$route.path,
          query: { search: this.search },
        });
        this.update_items();
      }
    } else {
      this.update_items();
    }
    this.stocks = [
      { text: this.$t("all_categories"), value: "all", available: true },
      { text: this.$t("positive"), value: "positive", available: true },
      { text: this.$t("low_stock"), value: "low" },
      { text: this.$t("equal_to_zero"), value: "zero", available: true },
      { text: this.$t("out_of_stock"), value: "out", available: true },
    ];
    this.getTopCategories();
    if (this.target === "composite") {
      this.category = { name: this.$t("composite_item"), _id: 123 };
      this.router_link = "/items-list/composite";
    } else if (this.target === "show_on_bot") {
      this.category = { name: this.$t("online_store"), _id: 234 };
      this.router_link = "/item-list/store";
    } else {
      if (
        this.target === undefined &&
        this.category.name === this.$t("composite_item")
      ) {
        this.category = { name: this.$t("all_categories"), _id: "" };
        this.router_link = "/items/list";
      } else {
        this.category = this.$store.state.category1;
      }
    }
    this.user = this.$store.state.user;
  },
};
</script>
